// Module
var code = " <h2>Assignment 3 description</h2> <p>Submit:</p> <ol> <li>List of tasks</li> </ol> ";
// Exports
export default code;